import React from "react";
import styled from "styled-components";
import { getHomeParagraph } from "../../../../api/axios";
import useSWR from "swr";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

export default function ParagraphCard() {
  const theme = useTheme();
  const { data: paragraph } = useSWR(
    `getHomeParagraph`,
    async () => {
      try {
        const { data } = await getHomeParagraph();
        return data?.data?.[0];
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );
  const Image = styled.img`
  border-radius: 60px;
  border: 1px solid ${theme.palette.primary.main};
  height: 450px;
  width: 350px;
  object-fit: cover;
  box-shadow: -30px 30px 40px rgba(0, 75, 117, 0.15);
  transition: all 1s;

  :hover {
    transform: scale(1.05);
  }

  @media (max-width: 1180px) {
    height: 420px;
    width: 330px;
  }

  @media (max-width: 1000px) {
    height: 400px;
    width: 300px;
  }

  @media (max-width: 900px) {
    height: 340px;
    width: 255px;
    margin: 0 auto;
    border-radius: 40px;
  }

  @media (max-width: 768px) {
    height: 300px;
    width: 230px;
    border-radius: 30px;
  }

  @media (max-width: 480px) {
    height: 280px;
    width: 210px;
    border-radius: 25px;
  }

  @media (max-width: 450px) {
    height: 260px;
    width: 200px;
    border-radius: 20px;
  }

  @media (max-width: 385px) {
    height: 240px;
    width: 180px;
    border-radius: 18px;
  }

  @media (max-width: 320px) {
    height: 220px;
    width: 160px;
    border-radius: 15px;
  }
`;
  return (
    <Wrapper>
      <CardDetails>
        <Box component="div" sx={{
          display: 'flex'
        }}>
        <Image src={paragraph?.paragraph_image} />
        </Box>
        <Description1>
          <Box component="div">
          <p>{paragraph?.paragraph}</p>
          </Box>
        </Description1>
      </CardDetails>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin: 0 auto;

  @media (max-width: 900px) {
    max-width: 850px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0 15px;
  }

  @media (max-width: 550px) {
    max-width: 450px;
    padding: 0 10px;
  }

  @media (max-width: 480px) {
    padding: 0 8px;
  }

  @media (max-width: 370px) {
    max-width: 100%;
    padding: 0 5px;
  }

  @media (max-width: 320px) {
    padding: 0 3px;
  }
`;

const CardDetails = styled.div`
  margin: 0 auto;
  padding: 50px 0px;
  display: grid;
  grid-template-columns: 360px auto;
  gap: 50px;

  @media (max-width: 1150px) {
    gap: 30px;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 300px auto;
    gap: 40px;
    padding: 100px 0px 60px;
  }

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 60px 0px 20px;
  }

  @media (max-width: 768px) {
    gap: 25px;
    padding: 40px 0px 15px;
  }

  @media (max-width: 480px) {
    gap: 20px;
    padding: 30px 0px 10px;
  }

  @media (max-width: 460px) {
    gap: 15px;
    padding: 25px 0px 10px;
  }

  @media (max-width: 360px) {
    gap: 12px;
    padding: 20px 0px 8px;
  }

  @media (max-width: 320px) {
    gap: 10px;
    padding: 15px 0px 5px;
  }
`;

const Description1 = styled.div`
  color: #000000;
  line-height: 30px;
  font-size: 20px;
  font-weight: 500;
  text-align: justify;
  padding: 0px 0px 0 0;
  white-space: pre-line;
  transition: all 1s;

  :hover {
    transform: scale(1.05);
  }

  @media (max-width: 1280px) {
    font-size: 18.5px;
    line-height: 28px;
    padding-top: 0;
  }

  @media (max-width: 1150px) {
    font-size: 18px;
    line-height: 27px;
  }

  @media (max-width: 1000px) {
    font-size: 17px;
    line-height: 26px;
  }

  @media (max-width: 835px) {
    font-size: 16px;
    line-height: 25px;
  }

  @media (max-width: 900px) {
    padding: 0px 0px 20px;
    font-size: 17px;
    line-height: 26px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
    text-align: left;
  }

  @media (max-width: 550px) {
    padding: 0px 0px 0;
    font-size: 15px;
    line-height: 23px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 22px;
  }

  @media (max-width: 460px) {
    padding: 0px 10px 30px 0;
    font-size: 14px;
    line-height: 21px;
  }

  @media (max-width: 360px) {
    padding: 0px 8px 25px 0;
    font-size: 13px;
    line-height: 20px;
  }

  @media (max-width: 320px) {
    padding: 0px 5px 20px 0;
    font-size: 12px;
    line-height: 19px;
  }
`;
